import { FormattedMessage } from "react-intl";

const CorporateSidebarItems = [
  {
    link: "/corporate/requirement-listing",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.6}
        stroke="currentColor"
        className="w-5 h-5"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M9 5h6M9 9h6m-6 4h6m-6 4h6M5 3h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2z"
        />
      </svg>
    ),
    text: (
      <FormattedMessage
        id="RECRUITER.SIDEBAR.MENU.REQUIREMENTS"
        defaultMessage="Requirements"
      />
    ),
  },
  // 👇 New Biddings item
  {
    link: "/corporate/biddings",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.6}
        stroke="currentColor"
        className="w-5 h-5"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M3 7h18M3 12h18M3 17h18"
        />
      </svg>
    ),
    text: (
      <FormattedMessage
        id="RECRUITER.SIDEBAR.MENU.BIDDINGS"
        defaultMessage="Biddings"
      />
    ),
  },
];

const ModelItems = [
  {
    icon: (
      <svg
        aria-hidden="true"
        height="14"
        role="presentation"
        viewBox="0 0 16 14"
        className="w-5 h-5"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.5 0.5H1.5C0.583333 0.5 0 1.08333 0 2V12C0 12.9167 0.583333 13.5 1.5 13.5H14.5C15.4167 13.5 16 12.9166 16 11.9999V2C16 1.08333 15.4167 0.5 14.5 0.5ZM2 4.5H10V7.5H2V4.5ZM2 9.5H10V11.5H2C2 11.5 2 11.4583 2 11V9.5ZM14 11.5H12V4.5L14 4.49992V11C14 11.4583 14 11.5 14 11.5Z"
          fill="currentColor"
        ></path>
      </svg>
    ),
    text: (
      <FormattedMessage
        id="RECRUITER.TOPBAR.MENU.COMPANYPAGE"
        defaultMessage="Company Page"
      />
    ),
  },
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        focusable="false"
        role="img"
        fill="currentColor"
        viewBox="0 0 24 24"
        aria-hidden="true"
        className="w-5 h-5"
      >
        <path d="M12 12c2.486 0 4.5-2.014 4.5-4.5S14.486 3 12 3a4.499 4.499 0 00-4.5 4.5C7.5 9.986 9.514 12 12 12zm0 2.25c-3.004 0-9 1.508-9 4.5v1.75a.5.5 0 00.5.5h17a.5.5 0 00.5-.5v-1.75c0-2.992-5.996-4.5-9-4.5z"></path>
      </svg>
    ),
    text: (
      <FormattedMessage
        id="RECRUITER.TOPBAR.MENU.USERS"
        defaultMessage="Users"
      />
    ),
  },
  {
    icon: (
      <svg
        className="w-5 h-5"
        aria-hidden="true"
        height="24"
        role="presentation"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M23 8.5V20.5C23 20.8 22.8 21 22.5 21H4.5C4.2 21 4 20.8 4 20.5V19H20.5C20.8 19 21 18.8 21 18.5V8H22.5C22.8 8 23 8.3 23 8.5Z"
          fill="currentColor"
        ></path>
        <path
          d="M15 4H1.4C1.2 4 1 4.1 1 4.4V16.7C1 16.9 1.2 17.1 1.4 17.1H18.6C18.8 17.1 19 16.9 19 16.7V4.4C19 4.2 18.8 4 18.6 4H15ZM2.7 8.8C4.3 8.5 5.6 7.2 5.9 5.6H14.2C14.5 7.2 15.8 8.5 17.4 8.8V12.2C15.8 12.5 14.5 13.8 14.2 15.4H5.8C5.5 13.8 4.2 12.5 2.6 12.2L2.7 8.8ZM17.4 8C16.2 7.7 15.3 6.8 15.1 5.6H17C17.2 5.6 17.4 5.8 17.4 6V8ZM5 5.6C4.7 6.7 3.8 7.6 2.7 7.9V6C2.7 5.8 2.9 5.6 3.1 5.6H5ZM2.7 15V13.1C3.8 13.4 4.7 14.3 5 15.4H3.1C2.8 15.4 2.7 15.2 2.7 15ZM15 15.4C15.3 14.3 16.2 13.4 17.3 13.1V15C17.3 15.2 17.1 15.4 16.9 15.4H15Z"
          fill="currentColor"
        ></path>
        <path
          d="M10 7.19995C8.20001 7.19995 6.70001 8.69995 6.70001 10.5C6.70001 12.3 8.20001 13.8 10 13.8C11.8 13.8 13.3 12.3 13.3 10.5C13.3 8.69995 11.8 7.19995 10 7.19995ZM10 12.9C8.70001 12.9 7.60001 11.8 7.60001 10.5C7.60001 9.19995 8.70001 8.09995 10 8.09995C11.3 8.09995 12.4 9.19995 12.4 10.5C12.4 11.8 11.3 12.9 10 12.9Z"
          fill="currentColor"
        ></path>
      </svg>
    ),
    text: (
      <FormattedMessage
        id="RECRUITER.TOPBAR.MENU.BILLING.AND.INVOICES"
        defaultMessage="Billing and Invoices"
      />
    ),
  },
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        focusable="false"
        role="img"
        fill="currentColor"
        viewBox="0 0 20 20"
        aria-hidden="true"
        className="w-6 h-6"
      >
        <path
          fillRule="evenodd"
          d="M9 9c1.934 0 3.5-1.566 3.5-3.5S10.934 2 9 2a3.499 3.499 0 00-3.5 3.5C5.5 7.434 7.066 9 9 9zm0 1.75c-2.336 0-7 1.172-7 3.5v1.25a.5.5 0 00.5.5h6.92a4.685 4.685 0 01-.9-2.77c0-.909.257-1.757.703-2.477A7.418 7.418 0 009 10.75zm6.952 4.136c.292-.483.46-1.05.46-1.656a3.2 3.2 0 00-3.196-3.202 3.2 3.2 0 00-3.196 3.202 3.2 3.2 0 004.878 2.723l1.897 1.9a.5.5 0 00.706 0l.354-.353a.501.501 0 000-.708l-1.903-1.906zm-1.046-1.656a1.69 1.69 0 11-3.38 0 1.69 1.69 0 013.38 0z"
          clipRule="evenodd"
        ></path>
      </svg>
    ),
    text: "Subscription",
  },
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        focusable="false"
        role="img"
        fill="currentColor"
        viewBox="0 0 20 20"
        aria-hidden="true"
        className="w-6 h-6"
      >
        <path
          fillRule="evenodd"
          d="M9 9c1.934 0 3.5-1.566 3.5-3.5S10.934 2 9 2a3.499 3.499 0 00-3.5 3.5C5.5 7.434 7.066 9 9 9zm0 1.75c-2.336 0-7 1.172-7 3.5v1.25a.5.5 0 00.5.5h6.92a4.685 4.685 0 01-.9-2.77c0-.909.257-1.757.703-2.477A7.418 7.418 0 009 10.75zm6.952 4.136c.292-.483.46-1.05.46-1.656a3.2 3.2 0 00-3.196-3.202 3.2 3.2 0 00-3.196 3.202 3.2 3.2 0 004.878 2.723l1.897 1.9a.5.5 0 00.706 0l.354-.353a.501.501 0 000-.708l-1.903-1.906zm-1.046-1.656a1.69 1.69 0 11-3.38 0 1.69 1.69 0 013.38 0z"
          clipRule="evenodd"
        ></path>
      </svg>
    ),
    text: "Contact Us",
  },
];

const ModelBottomItem = [
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        focusable="false"
        role="img"
        fill="currentColor"
        viewBox="0 0 20 20"
        aria-hidden="true"
        className="w-5 h-5"
      >
        <path
          fillRule="evenodd"
          d="M8.269 2.448A.5.5 0 018.766 2h2.468a.5.5 0 01.497.448l.194 1.836a6.395 6.395 0 012.322 1.275l1.785-.765a.528.528 0 01.654.208L17.9 6.998a.473.473 0 01-.137.642l-1.59 1.086a5.735 5.735 0 010 2.548l1.59 1.086a.473.473 0 01.137.642l-1.213 1.996a.528.528 0 01-.654.208l-1.785-.765a6.396 6.396 0 01-2.322 1.275l-.194 1.836a.5.5 0 01-.497.448H8.766a.5.5 0 01-.497-.448l-.194-1.836a6.397 6.397 0 01-2.322-1.275l-1.785.765a.528.528 0 01-.655-.208L2.1 13.002a.473.473 0 01.138-.642l1.589-1.085a5.734 5.734 0 010-2.55L2.238 7.64a.473.473 0 01-.137-.642l1.213-1.996a.528.528 0 01.654-.208l1.785.765a6.395 6.395 0 012.322-1.275l.194-1.836zm1.73 11.043c2.03 0 3.675-1.563 3.675-3.49 0-1.929-1.645-3.492-3.674-3.492-2.03 0-3.675 1.563-3.675 3.491 0 1.928 1.645 3.49 3.675 3.49z"
          clipRule="evenodd"
        ></path>
      </svg>
    ),
    text: (
      <FormattedMessage
        id="RECRUITER.TOPBAR.MENU.ACCOUNT.SETTING"
        defaultMessage="Account Settings"
      />
    ),
    link: "/corporate/settings",
  },
];

export default CorporateSidebarItems;
export { CorporateSidebarItems, ModelBottomItem, ModelItems };
